import { SEASONS, WEEK_DAYS } from '@bridebook/web/lib/datepicker/constants';
import { z } from 'zod';

// Mirrors IDatePicker from Weddings.types.ts
// d: day number | WeekDay | WeekDay[] | null
// m: month number (Month = number) | Season | Month[] | null
const weekDaySchema = z.enum(WEEK_DAYS);
const seasonSchema = z.enum(SEASONS);

export const weddingDateSchema = z.object({
  d: z.union([z.number(), weekDaySchema, z.array(weekDaySchema), z.null()]),
  m: z.union([z.number(), seasonSchema, z.array(z.number()), z.null()]),
  y: z.number().nullable(),
});
